import React, { FC, useContext, useEffect, useState } from "react";
import AdvancedSearchLink from "../advancedSearchLink";
import FilterMenuSearchAdvanced from "../filterMenuSearchAdvanced";
import LastActiveFilter from "../lastActiveFilter";
import StyledToggle from "../styledToggle";
import LoadingSpinner from "../loadingSpinner";

import useSearch from "../../hooks/useSearch";

import { TranslationContext } from "../../context/TranslationContext";

type Props = {
  advancedSearchEnabled: boolean;
  setAdvancedSearchEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  setMoreFiltersEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  onResetClick: () => void;
};

const FilterMenuSearchExtended: FC<Props> = ({
  advancedSearchEnabled,
  setAdvancedSearchEnabled,
  onResetClick,
}) => {
  const { i } = useContext(TranslationContext);

  const { filteredSearch, setFilteredSearch, nbAdvancedFilters } = useSearch();

  return (
    <div
      data-testid="filter-menu-search-extended"
      className="FilterMenuSearchExtended flex flex-col md:px-6 md:py-6 px-5 pb-5 pt-5 md:space-y-0 space-y-6"
    >
      <div className="flex md:flex-row flex-col w-full space-y-10 md:space-y-0 md:justify-end">
        <div className="w-full md:w-1/3">
          <div className="w-full">
            <StyledToggle
              label={i("Certified profiles only")}
              checked={!!filteredSearch.isCertifiedOnly}
              handleChange={(checked) => {
                setFilteredSearch({ isCertifiedOnly: +checked });
              }}
            />
          </div>

          <div className="w-full mt-4">
            <StyledToggle
              label={i("Profiles with pictures only")}
              checked={!!filteredSearch.hasPictureOnly}
              handleChange={(checked) => {
                setFilteredSearch({ hasPictureOnly: +checked });
              }}
            />
          </div>
        </div>
        <div className="md:w-1/3 md:pl-[35px] w-full">
          <LastActiveFilter
            value={filteredSearch.lastVisitedDate}
            handleChange={(value) => {
              setFilteredSearch({ lastVisitedDate: +value });
            }}
          />
        </div>
      </div>

      <div className="">
        {advancedSearchEnabled && false && (
          <div>
            <div className="w-full h-[670px] flex justify-center items-center">
              <LoadingSpinner />
            </div>
          </div>
        )}
        {advancedSearchEnabled && <FilterMenuSearchAdvanced />}

        <AdvancedSearchLink
          onClick={() => setAdvancedSearchEnabled(!advancedSearchEnabled)}
          text={
            (advancedSearchEnabled ? i("Show less") : i("Advanced search")) +
            (nbAdvancedFilters > 0
              ? ` (${nbAdvancedFilters}
                  ${i(
                    (nbAdvancedFilters > 1 ? "filters" : "filter") + " applied"
                  )})`
              : "")
          }
        />

        {advancedSearchEnabled && (
          <AdvancedSearchLink
            onClick={onResetClick}
            text={i("Reset filters")}
          />
        )}
      </div>
    </div>
  );
};

export default FilterMenuSearchExtended;
